$(document).ready(function(){

/* $('.product__info-wrapper .product-form__input .select select').find('option[value=0]').attr('selected','selected');
  $(".product .product-form__buttons .product-form__submit").addClass("disabled_btn");
 $(document).on("change",".product__info-wrapper .product-form__input .select select",function(){
     
       if($(this).val()=="0")
       {
          $(this).closest('.product__info-wrapper').find(".product-form__submit").addClass("disabled_btn");
       }
       else
       {
          $(this).closest('.product__info-wrapper').find(".product-form__submit").removeClass("disabled_btn");
       }
       
    }); */
  
  // Faq Page Accordian Js 
 
  jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });

  $('.banner-slider-area').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
	// Giving Back Tabing Script
  
   $(document).on("click",".giving-tab-btn",function(){
  var id_tab=$(this).attr("data-val");
  $(".giving-tab-btn").removeClass("active");
  $(this).addClass("active");
  
  $(".giving-back-body-area").removeClass("active");
  $(".giving-back-body-area."+id_tab).addClass("active");
});

    
     $(document).on("change",".coll-varaint-dropdown",function(){
     
       if($(this).val()=="default")
       {
          $(this).parents('.card__content').find(".quick-add__submit").addClass("disabled_btn");
       }
       else
       {
         $(this).parents('.card__content').find(".quick-add__submit").removeClass("disabled_btn");
         var price=$(this).find(":selected").attr('data-price');
         var compare_at_price=$(this).find(":selected").attr('data-compare-at-price');
         var img=$(this).find(":selected").attr('data-image');
          if (compare_at_price) {
            $(this).parents('.card__content').find('.price__sale .price-item--regular').removeClass("hidden");
            $(this).parents('.card__content').find('.price__sale .price-item--regular').html(compare_at_price);
          }
          else {
            $(this).parents('.card__content').find('.price__sale .price-item--regular').addClass("hidden");
          }
          $(this).parents('.card__content').find('.price__regular .price-item--regular').html(price);
          $(this).parents('.card__content').find(' .price-item--sale').html(price);
          $(this).closest(".card-wrapper").find('.card__media').find("img").attr("srcset", ""+img);
          $(this).closest(".card-wrapper").find('.card__media').find("img").attr("src", ""+img);
       }
       
    });
	 
});
